import SectionIntro from "./SectionIntro";
import { featuredPicks } from "@/mocks/softwareData";

export default function FeaturedPicks() {
  return (
    <section id="featured" className="bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <SectionIntro
          eyebrow="EDITOR'S PICKS"
          title="装机必备 · 精选专题"
          desc="编辑手选并持续维护的实用专题，图文并茂、定期更新，读完即用。"
          center
        />

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {featuredPicks.map((f) => (
            <article
              key={f.name}
              className="group flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-colors hover:border-primary-200"
            >
              <div className="relative aspect-[10/7] overflow-hidden">
                <img
                  src={f.img}
                  alt={f.name}
                  className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-primary-500/95 px-2.5 py-1 text-xs font-semibold text-background-50">
                  {f.category}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4 md:p-5">
                <div className="flex items-start justify-between gap-2">
                  <h3 className="font-display text-base font-bold text-foreground-950">{f.name}</h3>
                </div>
                <p className="mt-0.5 text-xs font-medium text-primary-600">{f.sub}</p>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{f.desc}</p>
                <div className="mt-auto flex items-center justify-between pt-4">
                  <span className="flex items-center gap-1 text-xs text-foreground-400">
                    <i className="ri-refresh-line"></i>
                    {f.count}
                  </span>
                  <a
                    href="#guide"
                    className="flex h-8 w-8 items-center justify-center rounded-md bg-secondary-500 text-background-50 transition-colors hover:bg-secondary-600"
                    aria-label={`查看专题 ${f.name}`}
                  >
                    <i className="ri-arrow-right-line"></i>
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}